import ApiDataTablesContainer from "../../Componant/DataTable/ApiDataTables";

const ApiDataTables = () => {
  return (
    <div className="page-body">
      <ApiDataTablesContainer />
    </div>
  );
};

export default ApiDataTables;
